module.exports = __webpack_public_path__ + "img/pic_india_03.bc6c99a8.jpg";